import React from 'react';
import { Icon } from 'antd';

export const ComponentOkAction = ({ upload, type }) => {
	return upload ? (
		<>
			<Icon type="loading" />
			Guardando...
		</>
	) : type === 'itemCard' ? (
		'Actualizar'
	) : (
		'Guardar'
	);
};
